export default __webpack_public_path__ + "static/media/7SJ600.4360af16.png";